module.exports = __webpack_public_path__ + "img/CKD-min.67bac204.png";